import { useEffect } from 'react';

const LoadCookieyesScript = () => {
  useEffect(() => {
    const cookieyesScriptElement = document.getElementById('cookieyes');
    if (cookieyesScriptElement) return;

    const script = document.createElement('script');
    script.id = 'cookieyes';
    script.type = 'text/javascript';
    script.src = 'https://cdn-cookieyes.com/client_data/16e4a194ff7a7cb0229cb764/script.js';
    document.head.appendChild(script);

    return () => {
      document.querySelector('.cky-btn-revisit-wrapper.cky-revisit-bottom-left')?.remove();
    };
  }, []);

  return null;
};

export default LoadCookieyesScript;
